import { render, staticRenderFns } from "./CommunicationDetailModal.vue?vue&type=template&id=6346881a&"
import script from "./CommunicationDetailModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports